import { useTranslation } from 'react-i18next';

export default function CTASection() {
  const { t } = useTranslation();

  return (
    <section className="w-full">
      <div className="grid grid-cols-1 lg:grid-cols-2 min-h-[420px] md:min-h-[480px]">
        {/* Left: Image side */}
        <div className="relative overflow-hidden bg-accent-100/50">
          <img
            src="https://readdy.ai/api/search-image?query=A%20beautifully%20curated%20selection%20of%20contemporary%20fashion%20items%20including%20a%20cream%20knit%20sweater%20a%20brown%20leather%20belt%20gold%20tone%20sunglasses%20and%20a%20minimalist%20canvas%20tote%20bag%2C%20arranged%20on%20a%20warm%20textured%20linen%20background%2C%20soft%20natural%20daylight%2C%20clean%20composition%20with%20plenty%20of%20surrounding%20space%2C%20modern%20editorial%20style%2C%20harmonious%20neutral%20color%20palette%20with%20touches%20of%20warm%20ochre%20and%20sand%20tones%2C%20sophisticated%20lifestyle%20aesthetic&width=900&height=700&seq=cta-products-kakobuy-v3&orientation=landscape"
            alt="Kakobuy Finds"
            className="w-full h-full object-cover"
          />
        </div>

        {/* Right: CTA */}
        <div className="flex flex-col items-center justify-center text-center px-8 md:px-16 py-14 md:py-20 bg-background-50">
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 leading-tight">
            {t('cta.title.line1')}
            <br />
            <span className="text-primary-500">{t('cta.title.line2')}</span>
          </h2>
          <p className="mt-5 text-sm md:text-base text-foreground-500 max-w-md leading-relaxed">
            {t('cta.desc')}
          </p>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-foreground-900 text-background-50 font-semibold text-sm hover:bg-foreground-800 transition-all whitespace-nowrap cursor-pointer"
          >
            {t('cta.button')}
            <i className="ri-arrow-right-line text-base"></i>
          </a>
        </div>
      </div>
    </section>
  );
}